<!-- <p>dashboard-watch-list works!</p> -->
<div class="watchlist-container">
    <div class="title-list">
        <div class="title" *ngIf="panelData">
            <span>{{panelData.title}}</span>
            <mat-icon *ngIf="creating" [matMenuTriggerFor]="titleMenu"
                [matMenuTriggerData]="{panelData: panelData}">edit</mat-icon>
        </div>
        <div class="title" *ngIf="!panelData">
            <span>Watch List</span>
        </div>
        <ng-container *ngIf="panelData">
            <ng-container
                *ngIf="watchListAssets.length > 0 && flaggedAssets.length > 0 then both else one"></ng-container>
        </ng-container>
        <ng-container *ngIf="!panelData">
            <ng-container [ngTemplateOutlet]="example"></ng-container>
        </ng-container>

        <!-- <div class="message" *ngIf="!watchListAssets || watchListAssets.length == 0">No Assets On Watch List</div> -->
    </div>
</div>

<ng-template #example>
    <ejs-listbox [dataSource]='exampleData'
        [fields]='{text: "Next", value: "Id"}' cssClass='e-list-template'>
        <ng-template #itemTemplate let-data>
            <div style="padding: 0px 0.5em;" class="ejs-listbox-item alignRow app-icon--goto">
                <span matTooltipPosition="right">{{ data.Name }} - {{ data.Description }}</span>
                <span class="me-auto"></span>
                <mat-icon/>
            </div>
        </ng-template>
    </ejs-listbox>
</ng-template>

<ng-template #both>
    <ejs-tab id="element">
        <e-tabitems>
            <e-tabitem>
                <ng-template #headerText>
                    <mat-icon>visibility</mat-icon>&nbsp;Watch List
                </ng-template>
                <ng-template #content>
                    <div>
                        <ejs-listbox *ngIf="watchListAssets" [dataSource]='watchListAssets' [fields]="fields"
                            cssClass='e-list-template'>
                            <ng-template #itemTemplate let-data>
                                <div title="Click to View in Watch List" style="padding: 0px 0.5em;" class="app-icon--goto"
                                    class="ejs-listbox-item alignRow" (click)="goToWatchList(data)">
                                    <span matTooltipPosition="right">{{ data.Name }} - {{ data.Description }}</span>
                                    <span class="me-auto"></span>
                                    <mat-icon matTooltip="Go to Functional Location"
                                        (click)="goToFunctionalLocation(data)"/>
                                </div>
                            </ng-template>
                        </ejs-listbox>
                    </div>
                </ng-template>
            </e-tabitem>
            <e-tabitem>
                <ng-template #headerText>
                    <mat-icon>flag</mat-icon>&nbsp;Flagged Assets
                </ng-template>
                <ng-template #content>
                    <div>
                        <ejs-listbox *ngIf="flaggedAssets" [dataSource]='flaggedAssets' [fields]="fields"
                            cssClass='e-list-template'>
                            <ng-template #itemTemplate let-data>
                                <div title="Click to View in Flagged List" style="padding: 0px 0.5em;" class="app-icon--goto"
                                    class="ejs-listbox-item alignRow" (click)="goToFlagged(data)">
                                    <span matTooltipPosition="right">{{ data.Name }} - {{ data.Description }}</span>
                                    <span> - {{data.Comment}}</span>
                                    <span class="me-auto"></span>
                                    <mat-icon matTooltip="Go to Functional Location"
                                        (click)="goToFunctionalLocation(data)"/>
                                </div>
                            </ng-template>
                        </ejs-listbox>
                    </div>
                </ng-template>
            </e-tabitem>
        </e-tabitems>
    </ejs-tab>
</ng-template>

<ng-template #one>
    <ejs-listbox *ngIf="watchListAssets" [dataSource]='watchListAssets' [fields]="fields" cssClass='e-list-template'>
        <ng-template #itemTemplate let-data>
            <div title="Click to View in Watch List" style="padding: 0px 0.5em;" class="ejs-listbox-item alignRow app-icon--goto"
                (click)="goToWatchList(data)">
                <span matTooltipPosition="right">{{ data.Name }} - {{ data.Description }}</span>
                <span class="me-auto"></span>
                <mat-icon matTooltip="Go to Functional Location"
                    (click)="goToFunctionalLocation(data)"/>
            </div>
        </ng-template>
    </ejs-listbox>
</ng-template>